export enum ThemeType {
  Light = "light",
  Dark = "dark",
}

export enum ThemeActionKind {
  CHANGE_THEME_DARK = "CHANGE_THEME_DARK",
  CHANGE_THEME_LIGHT = "CHANGE_THEME_LIGHT",
}

export enum MovieTVType {
  Movie = "movie",
  TV = "tv",
}

export enum RoutePaths {
  HOME = "/",
  POPULAR = "/popular",
  TRENDING = "/trending",
  NEWEST = "/newest",
  TOP_RATED = "/top-rated",
  SEARCH = "/search",
}
